import { HubspotServices, SalesforceServices } from '@clearkit/icons';
import {
  CKActionMenu,
  CKButton,
  CKDropdownChevron,
  CKLayoutHorizontal,
  CKPopover,
} from 'clearkit';
import { Link } from 'react-router-dom';

import { useCRMConnectors } from '../../hooks/useCRMConnectors';
import {
  ImplementationCard,
  ImplementationCardWrapperProps,
} from '../ImplementationCard';
import { LoadingCard } from './LoadingCard';

const iconClasses = 'w-4 h-4';

const ActionMenu = () => (
  <CKActionMenu>
    <CKActionMenu.Item
      as={Link}
      leftIcon={<SalesforceServices className={iconClasses} />}
      to="/enrichment/salesforce"
    >
      Connect to Salesforce
    </CKActionMenu.Item>
    <CKActionMenu.Item
      as={Link}
      leftIcon={<HubspotServices className={iconClasses} />}
      to="/enrichment/hubspot"
    >
      Connect to Hubspot
    </CKActionMenu.Item>
  </CKActionMenu>
);

export const ConnectCRM = ({
  forceVisibility,
}: ImplementationCardWrapperProps) => {
  const { defaultConnector, loading } = useCRMConnectors();
  const isConnected = defaultConnector;

  if (loading) return <LoadingCard />;
  if (isConnected && !forceVisibility) return null;

  return (
    <ImplementationCard progress={isConnected ? 100 : 0}>
      <ImplementationCard.Heading>Connect your CRM</ImplementationCard.Heading>
      <ImplementationCard.Description>
        Perform a data test, enrich company and contact data from your CRM, and
        unlock powerful segmentation and workflows with account, contact, and
        lead data.
      </ImplementationCard.Description>
      <ImplementationCard.Footer>
        <CKPopover popover={<ActionMenu />}>
          <CKButton variant="bold" variantColor="green">
            <CKLayoutHorizontal as="span" gap="0.125rem" justifyContent="start">
              Connect your CRM
              <CKDropdownChevron className="top-0.5" />
            </CKLayoutHorizontal>
          </CKButton>
        </CKPopover>
        <CKButton
          as="a"
          href="https://clearbit.com/integrations"
          variant="tertiary"
          variantColor="blue"
        >
          Learn more
        </CKButton>
      </ImplementationCard.Footer>
    </ImplementationCard>
  );
};
